import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { get_integration_config_field_sensitive_value_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { AUTOMATION_LATEST_VERSION_KEY } from '@/utils/queryKeys.ts';
import { AutomationVersion } from '@/types/automations.ts';

export type UpdateConfigFieldSensitiveValueParams = {
  stepId: string;
  fieldId: string;
  value: string | null;
};

const useUpdateConfigFieldSensitiveValue = (): UseMutationResult<
  AutomationVersion,
  AxiosError,
  UpdateConfigFieldSensitiveValueParams
> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();
  const queryClient = useQueryClient();
  const queryKey = AUTOMATION_LATEST_VERSION_KEY(automationId);

  return useMutation({
    mutationFn: async ({ stepId, fieldId, value }: UpdateConfigFieldSensitiveValueParams) => {
      const url = get_integration_config_field_sensitive_value_url(automationId, stepId, fieldId);
      const response = await apiClient.patch<AutomationVersion>(url, { value });

      queryClient.setQueryData(queryKey, response.data);

      return response.data;
    },
  });
};

export default useUpdateConfigFieldSensitiveValue;
